import { createSlice } from '@reduxjs/toolkit';

import { layoutInitialState } from './helpers';

const initialState = {
    ...layoutInitialState,
};
Object.freeze(initialState);

const userSlice = createSlice({
    name: 'editor',
    initialState: initialState,
    reducers: {
        updateLayout(state, { payload }) {
            Object.assign(state, payload);
        },
        resetLayout(state) {
            Object.assign(state, initialState);
        },
    },
    extraReducers: {},
});

export const { updateLayout, resetLayout } = userSlice.actions;

export default userSlice.reducer;
